import React, { useMemo } from "react";
import ReactPlayer from "react-player";

import { ImageIcon } from "../../Svg";
import { isVideo, noop } from "../../utils";
import { EmptyImageWrapper } from "../CampaignCreatePhotoEditor.styled";

const PhotoEditorCreative = ({ url, playing, muted, onLoad }) => {
  const isImageURL = useMemo(() => !isVideo(url), [url]);
  if (!url) {
    return (
      <EmptyImageWrapper data-testid="test_EmptyImageWrapper_Creative_Empty">
        <ImageIcon />
      </EmptyImageWrapper>
    );
  }

  return isImageURL ? (
    <img src={url} alt="Header Image" onLoad={onLoad || noop} />
  ) : (
    <ReactPlayer
      url={url}
      loop
      playing={playing}
      muted={muted}
      width="100%"
      height="100%"
      controls={false}
      data-testid="test_ReactPlayer_Creative"
    />
  );
};

export default PhotoEditorCreative;
